import(/* webpackMode: "eager" */ "/vercel/path0/src/app/game/layout.tsx");
